import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AllServicesComponent } from './all-services/all-services.component';
import { AddServiceComponent } from './add-service/add-service.component';
import { AddMicroServiceComponent } from './add-micro-service/add-micro-service.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { EditServiceComponent } from './edit-service/edit-service.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    AllServicesComponent,
    AddServiceComponent,
    AddMicroServiceComponent,
    EditServiceComponent
  ],
  imports: [CommonModule, MatDialogModule,
     FormsModule,
     MatSlideToggleModule,
      ReactiveFormsModule]
})
export class MangeServiceModule {}
